itsoftApp.createModule("uteka", ["insertUtekaSlider"], function () {
    window.isLoadedUtekasProducts = false;

    if (window.isLoadedUtekasProducts === false) {
        window.isLoadedUtekasProducts = true;

        itsoftApp.modules.insertUtekaSlider.callback();
    }
});